import { useNavigate } from 'react-router-dom';
import { LOGO_URL, SOCIAL_LINKS } from '../data';

export default function PlataformaFooter() {
  const navigate = useNavigate();

  const goTo = (target: string) => () => {
    if (target.startsWith('#')) {
      const el = document.querySelector(target);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    navigate(target);
  };

  return (
    <footer className="bg-primary-600 pb-14 pt-16 text-background-100">
      <div className="mx-auto w-full max-w-[1060px] px-6">
        <div className="grid gap-10 pb-2 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <img src={LOGO_URL} alt="GetPoints" className="logo-glow h-11 w-auto" />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-100">
              Plataforma de incentivo, premiação e gamificação para times comerciais. Mais engajamento, mais
              execução, mais resultado.
            </p>
            <div className="mt-6 flex gap-3">
              {SOCIAL_LINKS.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-background-100 transition-colors hover:bg-white/20"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">Navegue</h4>
            <ul className="mt-5 space-y-3">
              {[
                { label: 'Visão geral', target: '#modulos' },
                { label: 'Estratégia', target: '#estrategia' },
                { label: 'Engajamento', target: '#engajamento' },
                { label: 'Premiação', target: '#premiacao' },
                { label: 'Confiança', target: '#confianca' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.target}
                    onClick={(event) => {
                      event.preventDefault();
                      goTo(link.target)();
                    }}
                    className="text-sm text-background-100 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">Comece agora</h4>
            <ul className="mt-5 space-y-3">
              {[
                { label: 'Solicitar demonstração', target: '/solicitar-demo' },
                { label: 'Fale com especialista', target: '/solicitar-demo' },
                { label: 'Voltar ao início', target: '/' },
              ].map((link) => (
                <li key={link.label}>
                  <a
                    href={link.target}
                    onClick={(event) => {
                      event.preventDefault();
                      goTo(link.target)();
                    }}
                    className="text-sm text-background-100 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold uppercase tracking-wider text-background-50">Contato</h4>
            <ul className="mt-5 space-y-3 text-sm text-background-100">
              <li>
                <a href="mailto:contato@getpoints.com.br" className="transition-colors hover:text-background-50">
                  contato@getpoints.com.br
                </a>
              </li>
              <li>
                <a href="tel:+551140035642" className="transition-colors hover:text-background-50">
                  (11) 4003-5642
                </a>
              </li>
              <li>São Paulo · SP</li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
}